@import './cpsl-grid.vars';

// Grid
// --------------------------------------------------

:host {
  /**
   * @prop --cpsl-grid-padding: Padding for the Grid
   * @prop --cpsl-grid-padding-xs: Padding for the Grid on xs screens
   * @prop --cpsl-grid-padding-sm: Padding for the Grid on sm screens
   * @prop --cpsl-grid-padding-md: Padding for the Grid on md screens
   * @prop --cpsl-grid-padding-lg: Padding for the Grid on lg screens
   * @prop --cpsl-grid-padding-xl: Padding for the Grid on xl screens
   *
   * @prop --cpsl-grid-width: Width of the fixed Grid
   * @prop --cpsl-grid-width-xs: Width of the fixed Grid on xs screens
   * @prop --cpsl-grid-width-sm: Width of the fixed Grid on sm screens
   * @prop --cpsl-grid-width-md: Width of the fixed Grid on md screens
   * @prop --cpsl-grid-width-lg: Width of the fixed Grid on lg screens
   * @prop --cpsl-grid-width-xl: Width of the fixed Grid on xl screens
   */

  @include make-breakpoint-padding($grid-paddings);
  @include margin-horizontal(auto);

  display: block;

  flex: 1;
}

// Fixed Grid
// --------------------------------------------------

:host(.grid-fixed) {
  @include make-grid-widths();
}

// Grid Padding
// --------------------------------------------------

// Remove the padding from grid and all immediate children columns
:host(.cpsl-no-padding) {
  --cpsl-grid-column-padding: 0;
  --cpsl-grid-column-padding-xs: 0;
  --cpsl-grid-column-padding-sm: 0;
  --cpsl-grid-column-padding-md: 0;
  --cpsl-grid-column-padding-lg: 0;
  --cpsl-grid-column-padding-xl: 0;
}
